import { render, staticRenderFns } from "./moveDialog.vue?vue&type=template&id=675d9be4&scoped=true&"
import script from "./moveDialog.vue?vue&type=script&lang=js&"
export * from "./moveDialog.vue?vue&type=script&lang=js&"
import style0 from "./moveDialog.vue?vue&type=style&index=0&id=675d9be4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675d9be4",
  null
  
)

export default component.exports